export enum SendStatusEnum {
	Pending = 'Pending',
	Sent = 'Sent',
	Failed = 'Failed',
}

export const SendStatusArray = [SendStatusEnum.Pending, SendStatusEnum.Sent, SendStatusEnum.Failed];
